export var ApplicationSortType;
(function (ApplicationSortType) {
    ApplicationSortType["CreatedDateDescending"] = "CreatedDateDescending";
    ApplicationSortType["CreatedDateAscending"] = "CreatedDateAscending";
    ApplicationSortType["ConfirmedDateDescending"] = "ConfirmedDateDescending";
    ApplicationSortType["ConfirmedDateAscending"] = "ConfirmedDateAscending";
    ApplicationSortType["DeclinedDateDescending"] = "DeclinedDateDescending";
    ApplicationSortType["DeclinedDateAscending"] = "DeclinedDateAscending";
})(ApplicationSortType || (ApplicationSortType = {}));
